import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjectVySida';
import { objektVyGrupp } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyGrupp';
// import { associeradObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/associeradObjektVy';
import { IObjektVy } from '../../../../../Types/ObjektVy';
import { standardVy, objektLänk } from '../../../../../Utils/ObjektVyUtils';
import columnDefVy from '../../../_Common/Components/BusinessCollectionComponents/columnDefVy';
import faltVy from '../../../_Common/Components/BusinessCollectionComponents/faltVy';

const forstaSida: IObjektVy = ObjektVySida(
  'forstaSida',
  [
    [
      objektVyGrupp(
        'Verifikationsrad1',
        [faltVy('ArVernrRadnr'), 'BOKF_AR', objektLänk('Bokfver')],
        ''
      ),
      objektVyGrupp(
        'Verifikationsrad2',
        [
          columnDefVy({
            attributeDef: 'Bokfver.DATUM',
            caption: 'Datum',
          }),
          'Kontostrang',
          'DEBET',
          'KREDIT',
          'Vertext',
          columnDefVy({
            attributeDef: 'Enhet.ENHET',
            caption: 'Enhet',
          }),
          'ANTAL',
          'AvslutatProjektVernr',
        ],
        'Övrigt'
      ),
    ],
  ],
  1,
  'Verifikationsrad'
);

const standard: IObjektVy = standardVy([forstaSida]);

export const Bokfkonteringvyer: IObjektVy[] = [standard];
